module.exports = __webpack_public_path__ + "static/media/android-play.7a4bef69.svg";